import { Product } from '../models/Product';

const findProductByTaxRollId = (products: Product[], taxRollId: string) =>
  products.find(product => product.taxrollId === taxRollId);

export default findProductByTaxRollId;
